import { ReduxAction } from './ReduxUtils'
interface Reducer<S, T> {
    (state: S, action: ReduxAction<T>): S
   }
/**
  Creates a reducer.
  @param {string} initialState - The initial state for this reducer.
  @param {object} handlers - Keys are action types (strings), values are reducers (functions).
  @return {object} A reducer object.
 */
export const createReducer = <State>(
	initialState:State,
	handlers: Lookup<Reducer<State, {}>>
) => {
  
	// create the reducer function
	return (state:State = initialState, action:ReduxAction<{}>) => {

		// look for the handler
		const handler = handlers[action.type]

		// no handler no cry
		if (!handler) return state

		// execute the handler 
		return handler(state, action)
	}
}
